import axios from '@/axios'

const state = {
    invoicingInformation: [],
    notRetiredInvoicingBatchTypes: [],
    invoicingTemplateTypes: [],

    invoicingTimePeriod: [],
    invoicingPeriodTypes: [],
};

const getters = {
    getInvoicingInformation: (state) => state.invoicingInformation,
    getNotRetiredInvoicingBatchTypes: (state) => state.notRetiredInvoicingBatchTypes,
    getInvoicingTemplateTypes: (state) => state.invoicingTemplateTypes,

    getInvoicingTimePeriod: (state) => state.invoicingTimePeriod,
    getInvoicingPeriodTypes: (state) => state.invoicingPeriodTypes
};

const actions = {
    async loadNotRetiredBatchTypesForInvoicing(context) {
        await axios().get(`/getNotRetiredBatchTypesForInvoicing`)
            .then(response => {
                context.commit('setNotRetiredInvoicingBatchTypes', response.data.notRetiredInvoicingBatchTypes)
            })
    },
    async loadInvoicingInformation(context) {
        await axios().get(`/getInvoicingInformation`)
            .then(response => {
                context.commit('setInvoicingInformation', response.data.invoicingInformation)
                context.commit('setTemplateTypes', response.data.invoicingTemplateTypes)
            })
    },
    async loadInvoicingTimePeriod(context) {
        await axios().get(`/getInvoicingTimePeriod`)
            .then(response => {
                context.commit('setInvoicingTimePeriod', response.data.invoicingTimePeriod)
                context.commit('setInvoicingPeriodTypes', response.data.invoicingPeriodTypes)

            })
    },
    async addInvoicingTimePeriod(context, data) {
        await axios().post(`/addInvoicingTimePeriod`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async updateInvoicingTimePeriod(context, data) {
        await axios().post(`/updateInvoicingTimePeriod`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async deleteInvoicingTimePeriod(context, data) {
        await axios().post(`/deleteInvoicingTimePeriod`, {
            itemId: data.itemId
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async addInvoicingInformation(context, data) {
        await axios().post(`/addInvoicingInformation`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async updateInvoicingInformation(context, data) {
        await axios().post(`/updateInvoicingInformation`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async deleteInvoicingInformation(context, data) {
        await axios().post(`/deleteInvoicingInformation`, {
            itemId: data.itemId
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
};

const mutations = {
    setInvoicingInformation: (state, invoicingInformation) => (state.invoicingInformation = invoicingInformation),
    setNotRetiredInvoicingBatchTypes: (state, notRetiredInvoicingBatchTypes) => (state.notRetiredInvoicingBatchTypes = notRetiredInvoicingBatchTypes),
    setTemplateTypes: (state, invoicingTemplateTypes) => (state.invoicingTemplateTypes = invoicingTemplateTypes),

    setInvoicingTimePeriod: (state, invoicingTimePeriod) => (state.invoicingTimePeriod = invoicingTimePeriod),
    setInvoicingPeriodTypes: (state, invoicingPeriodTypes) => (state.invoicingPeriodTypes = invoicingPeriodTypes),
};

export default {
    state,
    getters,
    actions,
    mutations
}
